import React from 'react';
import { Modal, Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import MiniSteps from '../../../components/MiniSteps/MiniSteps';
import useOnBoardingPopUpViewModel from './OnBoardingPopUp.vm';
import useDeviceType from '../../../hooks/useDeviceType';
import './OnBoardingPopUp.style.scss';

const OnBoardingPopUp = ({ open, onClose }) => {
    const vm = useOnBoardingPopUpViewModel({ onClose });
    const { isMobile } = useDeviceType();

    return (
        <Modal open={open} onClose={vm.handleClose} className="OnBoardingPopUp">
            <div className="modal-box">
                <div className="closeButton" onClick={vm.handleClose}>X</div>
                {isMobile ? <OnBoardingMobile vm={vm} /> : <OnBoardingDesktop vm={vm} />}
            </div>
        </Modal>
    );
};

const Header = ({ step, showLogo }) => (
    <div className="header">
        {showLogo && <div className="logo-pickx" />}
        <h2 className="title gold-gradient-text">
            <FormattedMessage id={`popUp.onboardingPopUp.steps.${step}.title`} />
        </h2>
    </div>
);

const Footer = ({ vm, showMiniSteps }) => (
    <div className="footer">
        <div className="buttons">
            {vm.currStep > 0 && (
                <Button className="btn backBtn" onClick={vm.handleBackStepClick}>
                    <FormattedMessage id="popUp.onboardingPopUp.backBtn" />
                </Button>
            )}
            {vm.currStep < vm.steps.length - 1 ? (
                <Button className="btn nextBtn gold-background" onClick={vm.handleNextStepClick}>
                    <FormattedMessage id="popUp.onboardingPopUp.nextBtn" />
                </Button>
            ) : (
                <Button className="btn closeBtn gold-background" onClick={vm.handleClose}>
                    <FormattedMessage id="popUp.onboardingPopUp.closeBtn" />
                </Button>
            )}
        </div>
        {showMiniSteps && (
            <MiniSteps
                steps={vm.steps}
                currentStep={vm.currStep}
                onStepClick={vm.handleStepClick}
            />
        )}
    </div>
);

const Content = ({ step, isMobile, showText }) => (
    <div className="content">
        {showText && (
            <p>
                <FormattedMessage id={`popUp.onboardingPopUp.steps.${step}.content`} />
            </p>
        )}
        <div className={`screenshot _${step}`}>
            <video
                src={`/videos/welcome0${step + 1}${isMobile ? 'mobile' : ''}.mp4`}
                autoPlay
                muted
                loop
                width="100%"
            />
        </div>
    </div>
);

const OnBoardingDesktop = ({ vm }) => (
    <div className="center">
        <Header step={vm.currStep} showLogo />
        <Content step={vm.currStep} isMobile={false} showText />
        <Footer vm={vm} showMiniSteps />
    </div>
);

const OnBoardingMobile = ({ vm }) => (
    <div className="center">
        <Header step={vm.currStep} showLogo={false} />
        <p>
            <FormattedMessage id={`popUp.onboardingPopUp.steps.${vm.currStep}.content`} />
        </p>
        <Footer vm={vm} showMiniSteps={false} />
        <Content step={vm.currStep} isMobile showText={false} />
    </div>
);

export default OnBoardingPopUp;
